var map = {
	"./amazonas.json": "7194",
	"./ancash.json": "dcae",
	"./apurimac.json": "e73c",
	"./arequipa.json": "41bc",
	"./ayacucho.json": "5cd9",
	"./cajamarca.json": "ca1e",
	"./callao.json": "2e4e",
	"./cusco.json": "b110",
	"./extranjero.json": "222f",
	"./huancavelica.json": "3f19",
	"./huanuco.json": "0b62",
	"./ica.json": "7d64",
	"./junin.json": "e3a4",
	"./la-libertad.json": "3121",
	"./lambayeque.json": "e6d0",
	"./lima-provincias.json": "d98d",
	"./lima.json": "ae2a",
	"./loreto.json": "861b",
	"./madre-de-dios.json": "1a26",
	"./moquegua.json": "1da1",
	"./pasco.json": "8b96",
	"./perugeo.json": "9fa7",
	"./piura.json": "f226",
	"./puno.json": "0074",
	"./san-martin.json": "0e42",
	"./tacna.json": "a6ac",
	"./tumbes.json": "7241",
	"./ucayali.json": "e045"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3c52";